module.exports = __webpack_public_path__ + "media/images/icons/self-storage-medium-10x15-icon-c717016c7e36bec397279d433cde42bb.png";